export default "__VITE_ASSET__9f02be69__"